import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import useApiPostOrderError from '../../hooks/useApiPostOrderError';
import UiContext from '../../store/uiContext';
import useSubmit from '../../hooks/useSubmit';
import SubmitBtn from '../Button/SubmitBtn';

import './style.scss';

const PaymentAdd = () => {
  const { hasBillingError } = useApiPostOrderError();
  const { checkBillingInformation } = useSubmit();
  const uiContext = useContext(UiContext);
  const { t } = useTranslation();

  const errorRef = useRef(null);

  const callOfFadeAnimation = () => {
    if (!checkBillingInformation() && hasBillingError()) {
      uiContext.updateCardDeclined(uiContext.isCardDeclined.error, uiContext.isCardDeclined.warning);
    }
    if (!checkBillingInformation() && errorRef?.current && hasBillingError()) {
      errorRef?.current?.classList?.add('fade-animation');
      setTimeout(() => {
        errorRef.current.classList.remove('fade-animation');
      }, 2000);
    }
  };

  return (
    <>
      <SubmitBtn type="submit" handleFunc={callOfFadeAnimation} />
      <p
        className={classNames({
          'declined-error-message': true,
          hidden: !uiContext.isCardDeclined.error,
          active: uiContext.isCardDeclined.error,
          'mt-4': true,
        })}
        ref={errorRef}
      >
        {t('payment_add.please_fix_errors')}
      </p>
    </>
  );
};

export default PaymentAdd;
